interface SoldOutIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: number;
}

function SoldOutIcon({
  size = 36,
  className = '',
  onClick = (event) => {},
  ...props
}: SoldOutIconProps) {
  return (
    <span className={'flex items-center ' + className} onClick={onClick} {...props}>
      <svg
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='currentColor'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M10.0053 20C7.35233 19.9964 4.80974 18.9421 2.93402 17.0664C1.0591 15.1909 0.0037364 12.6485 3.53807e-05 9.99621C-0.0225538 1.17498 10.7769 -3.29866 16.9835 2.83464C23.3636 8.97164 18.9551 20.018 10.0053 20ZM6.27164 15.8767C12.5469 19.8013 19.8097 12.5322 15.8855 6.26336L6.27164 15.8767ZM10.0053 3.02892C4.58559 2.95122 1.16285 9.23738 4.12389 13.7293L13.7387 4.11593C12.6237 3.40493 11.3279 3.0282 10.005 3.0291L10.0053 3.02892Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default SoldOutIcon;
